import React, { useState } from 'react';
import { Flex, VStack } from '@chakra-ui/react';
import { Button, HeadingText } from '@spotoninc/nexus-react';
import QuickRegisterContent from './QuickRegisterContent';
import { getSpotOnDashboardUrl } from '../../utils/spotOnUrls';

const NRA_FOOTNOTE =
  'Valid for NRA session attendees only. Offer provides 5 months of complimentary access to Profit Assist. No credit card or payment information is required for activation. At the end of the 5-month trial period, service will automatically terminate unless the merchant elects to continue via a paid subscription or by transitioning to a qualifying SpotOn POS agreement. Standard rates for Profit Assist apply for standalone use following the trial. SpotOn is not responsible for any fees charged by your current POS provider for third-party integrations.';

const NraRegisterContent = () => {
  const [step, setStep] = useState('question');

  const handleYes = () => {
    window.location.assign(getSpotOnDashboardUrl());
  };

  const handleNo = () => {
    setStep('signup');
  };

  if (step === 'signup') {
    return (
      <QuickRegisterContent
        footnoteText={NRA_FOOTNOTE}
        loginLinkColor="#1C5DCD"
      />
    );
  }

  return (
    <VStack w="100%" h="100%" spacing={8} maxWidth="400px">
      <Flex direction="column" align="center" gap={2}>
        <HeadingText variant="heading2" color="neutral.900">
          Are you a SpotOn Client?
        </HeadingText>
      </Flex>

      <VStack spacing={4} w="auto" minW="70%">
        <Button variant="primary" onClick={handleYes} fullWidth>
          Yes
        </Button>
        <Button variant="secondary" onClick={handleNo} fullWidth>
          No
        </Button>
      </VStack>
    </VStack>
  );
};

export default NraRegisterContent;
